<!-- Header -->
<div class="header-container" #header>
  <section class="content__full-width">
    <div class="main__header flex">
      <div class="main__content py-xs px-xs flex justify-content-between align-items-center">
        <lib-header-logo [title]="headerTitle" [attr.data-qa-id]="'header-title'"></lib-header-logo>

        @if (department && department.originalLogo && !currentRouteEquals(router, appRoutes.selectDepartment)) {
          <section class="flex flex-column align-items-end">
            <img
              class="header__partner-logo"
              [class.header__partner-logo--square]="squareLogo"
              src="{{ department.originalLogo }}"
              alt="{{ department.name }} logo"
              [attr.data-qa-id]="'department-logo'"
            />
          </section>
        }
        @if (currentRouteEquals(router, appRoutes.selectDepartment)) {
          <section
            class="main__header__log-out flex align-items-center"
            (click)="logoutAdvisorPortal()"
            [attr.data-qa-id]="'advisor-portal-logout'"
          >
            <p class="small mr-xxs">Log out</p>
            <aff-logout-icon></aff-logout-icon>
          </section>
        }
      </div>
    </div>
  </section>

  <!-- Main Navigation -->
  @if (showNavigation) {
    <section class="content__full-width" [attr.data-qa-id]="'nav-bar'">
      <nav class="main__navigation">
        <div class="main__content px-xs flex">
          <a
            [attr.data-qa-id]="'home-link'"
            [routerLink]="[]"
            (click)="navigate()"
            [ngClass]="{ 'current-nav-item': currentRouteCheck() }"
          >
            <aff-home-icon class="home-icon"></aff-home-icon>
          </a>
          @if (isCustomersFeatureOn) {
            <a
              [attr.data-qa-id]="'customers-tab'"
              [routerLink]="[]"
              (click)="navigate('/' + appRoutes.customers + '/' + appRoutes.list)"
              class="main__navigation--link"
              [ngClass]="{ 'current-nav-item': currentRouteEquals(router, appRoutes.customers) }"
              >Customers</a
            >
          }
          @if (!isWorkReportHybridFeatureOn) {
            <a
              [routerLink]="[]"
              [attr.data-qa-id]="'applications-tab'"
              (click)="navigate('/' + appRoutes.applications + '/' + appRoutes.list)"
              class="main__navigation--link"
              [ngClass]="{ 'current-nav-item': currentRouteEquals(router, appRoutes.applications) }"
              >Applications</a
            >
          }
          @if (isWorkReportHybridFeatureOn) {
            <a [attr.data-qa-id]="'pay-data-tab'" class="main__navigation__c-default">Pay data</a>
          }
          <div class="main__navigation__right-buttons flex align-items-center">
            @if (departmentsDropDown?.length > 1) {
              <lib-dropdown-menu
                class="mr-xs"
                dropdownPosition="right"
                title="Switch Department"
                [list]="departmentsDropDown"
                [styleOptions]="{
                  menuHeadingStyles: { 'font-size': '1.4rem', color: 'white', 'letter-spacing': '0.05rem' },
                  menuItemStyles: { 'font-size': '1.4rem', color: 'grey', 'letter-spacing': '0.05rem' },
                  caretStyles: { color: 'white' }
                }"
                [isSelectedTickVisible]="true"
                (selected)="selectDepartment($event)"
                [attr.data-qa-id]="'select-department-dropdown'"
              ></lib-dropdown-menu>
            }
            <lib-button
              styleName="button--primary button--outline button--md"
              bgColor="#8694a4"
              textColor="white"
              borderStyle="1px solid white"
              buttonText="Log out"
              (clickEvent)="logout()"
              [attr.data-qa-id]="'logout-button'"
            ></lib-button>
          </div>
        </div>
      </nav>
    </section>
  }
</div>
